// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const LABELS = { cel: "CEL", python: "Python" } as const;

interface CodeDialectBadgeProps {
  dialect: keyof typeof LABELS;
  className?: string;
}

/** Small monospace badge marking which expression language a rule field expects (CEL or Python). */
export function CodeDialectBadge({ dialect, className }: CodeDialectBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn("px-1.5 py-0 font-mono text-[10px] font-normal text-muted-foreground", className)}
    >
      {LABELS[dialect]}
    </Badge>
  );
}
